module.exports = __webpack_public_path__ + "img/gb9123_18_b.prt.c798f163.jpg";